import Inputmask from 'inputmask';

export function getTariffFromCookie(cookie_string) {
    try {
        cookie_string = cookie_string
            .replace(/%2B/g, '+')
            .replace(/%2F/g, '/')
            .replace(/%3D/g, '=')
            .replace(/%20/g, ' ')
            .replace(/%3F/g, '?');
        return JSON.parse(decodeURIComponent(escape(atob(cookie_string))) || 'null') ?? null;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export function findSwipersInBlocks(block_selector, args = {}, sub_args = {}) {
    if (!block_selector) return null;

    const swipers = [];

    document.querySelectorAll(block_selector).forEach((block) => {
        const swiper = block.querySelector('.swiper');
        const pagination = block.querySelector('.slider-navs__pag');
        const prev = block.querySelector('.slider-navs__prev');
        const next = block.querySelector('.slider-navs__next');

        const sub_args_key = Object.keys(sub_args).find((key) => block.classList.contains(key));
        const current_sub_args = sub_args[sub_args_key] || {};
        const current_args = { ...args, ...current_sub_args };

        if (pagination) {
            current_args['pagination'] = {
                el: pagination,
                clickable: true,
                ...current_args['pagination']
            };
        }

        if (prev || next) {
            current_args['navigation'] = {
                prevEl: prev,
                nextEl: next,
                ...current_args['navigation']
            };
        }

        if (block.classList.contains('loading_block')) {
            const old_init = current_args?.on?.init || false;
            const init = function (swiper) {
                block.classList.remove('loading_block');
                if (old_init) old_init(swiper);
            };

            if (!current_args.on) current_args.on = {};

            current_args.on.init = init;
        }
        swipers.push(new Swiper(swiper, current_args));
    });
    return swipers.length ? swipers : null;
}

export function tabsListenerActive({
    selector = '[data-tabs-block=""]',
    callBack = false,
    defaultActiveFind = false,
    effects = true
} = {}) {
    jQuery(selector).each((_key, item) => {
        const currentBlock = jQuery(item);
        const labels = currentBlock
            .find('[data-tab_label_key]')
            .not(currentBlock.find('[data-tabs-block] [data-tab_label_key]'));
        const contents = currentBlock
            .find('[data-tab_content_key]')
            .not(currentBlock.find('[data-tabs-block] [data-tab_content_key]'));

        contents.filter(':not(.active)').hide();

        labels.on('click', (e) => {
            const key = e.target.dataset.tab_label_key ?? false;
            if (!key) return;

            if (effects) {
                jQuery(currentBlock).addClass('loading');
                setTimeout(() => {
                    jQuery(currentBlock).removeClass('loading');
                }, 200);
            }

            labels.removeClass('active');
            contents.removeClass('active').hide();

            jQuery(e.target).addClass('active');
            const currentContent = contents.filter(`[data-tab_content_key=${key}]`);
            currentContent.addClass('active').show();
            if (callBack) callBack([currentBlock, currentBlock, currentContent, e.target, key]);
        });

        if (defaultActiveFind && !currentBlock.filter('[data-tab_label_key].active').get(0)) {
            labels.filter('[data-tab_label_key]:first-child').trigger('click');
        }
    });
}

let is_scrolled = false;

export function scrollTo(e, prevenDefault = true) {
    if (is_scrolled && prevenDefault) {
        e.preventDefault();
        return;
    }

    let hash = jQuery(e.target)[0].getAttribute('href') || jQuery(e.target)[0].getAttribute('data-href');
    let elems = [];

    try {
        elems = document?.querySelectorAll(String(hash)) ?? [];
        // eslint-disable-next-line no-warning-comments
        // eslint-disable-next-line no-empty
    } catch {}

    let target = null;
    elems.forEach((item) => {
        if (jQuery(item).css('display') !== 'none') {
            target = jQuery(item);
            return;
        }
    });

    if (Array.from(hash)[0] !== '#' || !target || !target.get(0)) return;

    if (prevenDefault) {
        e.preventDefault();
    }

    is_scrolled = true;

    jQuery('html, body').animate(
        {
            scrollTop: target.offset().top - 150
        },
        1000,
        function () {
            is_scrolled = false;
        }
    );
}

export function applyInputMask() {
    const phoneInput = document.querySelectorAll('[type="tel"]');
    const im = new Inputmask('+7 (999) 999-99-99');
    im.mask(phoneInput);
}
